<template></template>
<script>
import rowCopier from "../helperFunctions/RowCopier";
export default {
  name: "PsRowCopier",
   data() {
    return {
      copyFunction: this.$props.cellClick,
      theTableRef: "",
      theFormatter: null
    };
  },
  props: {
    targetTable: {},
    excludeFields: {},
    width: "",
    tableRef: "",
    title: { type: String, default: "" },
    formatterString: {type: String },
    formatterStringOptions: {type: Array, default: function () {
      return ['copy-24']
    }},
    field: {type: String, default: "copierRow"},  
    formatter: {
      type: Function,
      default: (cell, formatterParams, onRendered) => {
        if (cell._cell != undefined && cell._cell.oldValue != null && cell._cell.oldValue != cell.getValue()) {
          cell.getElement().classList.add("redBorder");
        }
        return cell.getValue();
      },
    },
    tooltip: "",
    cssClass: String,
    hozAlign: {type: String, default: "center"},
    headerSort: {type: Boolean, default: false},
    headerClick: Function,
    print: {type: Boolean, default: true},
    cellClick: {type: Function},
    editor: {
      type: Function,
      default: null,
    },
  },
  inject: ["getTabulatorReference"],
  created: function () { },
  mounted() {
    this.theTableRef = this.getTabulatorReference;   
    this.cellClick = this.copyRow;
    var props = this.$props;
    var obj = {};
    obj.props = {};
    Object.assign(obj.props, this.$props);
    obj.props.formatter = this["definedIcons"];
    obj.props.cellClick = this.cellClick;
    obj.props.sorter = "string";
    obj.tableRef = this.theTableRef;
    window.Bus.$emit("NewColumnAdded", obj);
  },
  methods: {
    definedIcons() {
      var html = "";
       this.$props.formatterStringOptions.forEach(o => {         
        html += "<span class='icon-" + o + " icon-table' /> ";                         
      });
      return html;
    },
    copyRow(e, cell) {
         this.$emit("copy-event");
      var newObject = Object.assign({}, cell.getRow().getData());
      rowCopier.copyRow(this.$props.targetTable, newObject, this.$props.excludeFields, this);

    }
  }
}
</script>